import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import BannerImage from "../../assets/images/bussiness.jpg";
import { initializeAOS } from "../../Aos";

const HeroBanner = () => {
    useEffect(() => {
        initializeAOS();
    }, []);

    return (
        <section className="pt-[90px] pb-[70px] bg-[#D9F4EF]">
            <div className="container mx-auto px-4">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">

                    {/* LEFT CONTENT */}
                    <div data-aos="fade-right">
                        {/* Badge */}
                        <span className="inline-flex items-center gap-2 px-4 py-1 mb-5 text-sm font-medium bg-white rounded-full text-[#3F465D]">
                            <span className="w-2 h-2 bg-[#2CC7A3] rounded-full"></span>
                            Tailored financing
                        </span>

                        {/* Heading */}
                        <h1 className="text-[#1F2937] text-4xl lg:text-5xl font-semibold leading-tight mb-5">
                            Solution for every Cash flow scenario
                            {/* <br />
                            <span className="text-[#1F2937]">with Invexflow</span> */}
                        </h1>

                        {/* Description */}
                        <p className="text-[#6B7280] text-lg max-w-xl mb-8">
                            Choose the invoice discounting setup that fits your sales cycle, seasonality,
                            and risk profile. Modular, transparent, and build to scale.
                        </p>

                        {/* CTA Buttons */}
                        <div className="flex flex-wrap items-center gap-4">
                            <Link
                                to="/contact"
                                className="bg-[#2CC7A3] hover:bg-[#26b392] transition text-white px-6 py-3 rounded-lg font-semibold"
                            >
                                Start Free Assessment
                            </Link>

                            <a
                                href="#"
                                className="bg-white text-[#374151] px-6 py-3 rounded-lg font-semibold border border-gray-200 hover:bg-gray-50 transition"
                            >
                                Book a demo
                            </a>
                        </div>
                    </div>

                    {/* RIGHT IMAGE */}
                    <div data-aos="fade-left" className="flex justify-center">
                        <div className="bg-white rounded-xl shadow-md p-4 max-w-lg w-full">
                            <img
                                src={BannerImage}
                                alt="Invoice Discounting"
                                className="rounded-lg w-full object-cover"
                            />
                        </div>
                    </div>

                </div>
            </div>
        </section>
    );
};

export default HeroBanner;
